import { APIHandler, convertObjectToURL } from "utilities/apiHandler";

import { VendorSettingsEntity, VendorTypes } from "entity/vendor/common/vendor.types";

import {
    HomeDepotDisconnectResponse,
    HomeDepotRedirectInfoResponse,
    type IHomeDepotSettingsFormValues,
} from "./HomeDepotSettings.api.types";

export interface IHomeDepotSettingsHandler {
    get(): Promise<VendorSettingsEntity>;
    getRedirectInfo(userId?: number): Promise<HomeDepotRedirectInfoResponse>;
    update(formData: IHomeDepotSettingsFormValues): Promise<VendorSettingsEntity>;
    disconnectUser(userId: number): Promise<HomeDepotDisconnectResponse>;
    disconnectBuilder(): Promise<HomeDepotDisconnectResponse>;
}

export class HomeDepotSettingsHandler implements IHomeDepotSettingsHandler {
    async get(): Promise<VendorSettingsEntity> {
        return await APIHandler("/api/VendorAccounts/VendorSettings", {
            method: "GET",
            data: { vendorType: VendorTypes.TheHomeDepot },
            responseType: VendorSettingsEntity,
        });
    }

    async getRedirectInfo(userId?: number): Promise<HomeDepotRedirectInfoResponse> {
        return await APIHandler("/api/VendorAccounts/VendorRedirect", {
            method: "GET",
            data: { vendorType: VendorTypes.TheHomeDepot, undefined, userId },
            responseType: HomeDepotRedirectInfoResponse,
        });
    }

    async update(formData: IHomeDepotSettingsFormValues): Promise<VendorSettingsEntity> {
        return await APIHandler("/api/VendorAccounts/UpdateVendorAccountPreferences", {
            method: "PUT",
            data: formData,
            responseType: VendorSettingsEntity,
        });
    }

    async disconnectUser(userId: number): Promise<HomeDepotDisconnectResponse> {
        const qsParams = convertObjectToURL({ userId, vendorType: VendorTypes.TheHomeDepot });
        return await APIHandler(`/api/VendorAccounts?${qsParams}`, {
            method: "DELETE",
            responseType: HomeDepotDisconnectResponse,
        });
    }

    async disconnectBuilder(): Promise<HomeDepotDisconnectResponse> {
        const qsParams = convertObjectToURL({ vendorType: VendorTypes.TheHomeDepot });
        return await APIHandler(`/api/VendorAccounts?${qsParams}`, {
            method: "DELETE",
            responseType: HomeDepotDisconnectResponse,
        });
    }
}
